export const getFetchFilters = ({
  dataFilters,
  initialFetchFilters,
  managesTagsInternally,
  selectedTags,
  dataTags,
  selectedSort,
  initialSort,
}) => ({
  filters: dataFilters ?? initialFetchFilters ?? null,
  tags: (managesTagsInternally ? selectedTags : dataTags) ?? null,
  sort: selectedSort ?? initialSort ?? null,
});

export const getItemsSize = ({ fetchedData }) =>
  fetchedData?.pages?.[0]?.totalItems ?? 0;

export const getHasNoResult = ({ isLoading, itemsSize }) =>
  !isLoading && itemsSize === 0;

export const getFetchNextPage = ({ hasNextPage, fetchNextPage }) =>
  hasNextPage ? fetchNextPage : () => {};

export const getScreenReaderStatus = ({
  isFetching,
  isLoading,
  itemsSize,
  hasNoResult,
  screenReaderStatusItemName,
}) => {
  if (isFetching || isLoading) {
    return '';
  }

  if (itemsSize) {
    return n__(
      '%{itemsSize} %{itemNameSingular} found',
      '%{itemsSize} %{itemNamePlural} found',
      itemsSize,
    ).i__({
      itemsSize,
      itemNameSingular: screenReaderStatusItemName(1),
      itemNamePlural: screenReaderStatusItemName(2),
    });
  }

  if (hasNoResult) {
    return n__('No %{itemName} found').i__({
      itemName: screenReaderStatusItemName(0),
    });
  }

  return null;
};

export const getEffectiveSortBy = ({ isLoading, itemsSize, sortBy }) =>
  isLoading || itemsSize === 0 ? null : sortBy;
